[
  {
    "title": "All Zoom",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "gyroADC[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet Roll 50"
      },
      {
        "fields": [
          {
            "name": "axisP[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Roll 10"
      },
      {
        "fields": [
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#ffed6f",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet Pitch 50"
      },
      {
        "fields": [
          {
            "name": "axisP[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs pitch 10"
      },
      {
        "fields": [
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Gyro v Set Yaw 50"
      },
      {
        "fields": [
          {
            "name": "axisP[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisF[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -10,
                "max": 10
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PID Yaw 10"
      },
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Motors + Throttle"
      }
    ]
  },
  {
    "title": "Roll Std",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 120
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 120
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Motors"
      },
      {
        "fields": [
          {
            "name": "gyroADC[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fb8072",
            "lineWidth": 2
          },
          {
            "name": "rcCommands[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fccde5",
            "lineWidth": 2
          },
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffed6f",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet 1000"
      },
      {
        "fields": [
          {
            "name": "axisP[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Roll 50"
      }
    ]
  },
  {
    "title": "Pitch Std",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Motors"
      },
      {
        "fields": [
          {
            "name": "gyroADC[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffed6f",
            "lineWidth": 2
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffffb3",
            "lineWidth": 2
          },
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet 1000"
      },
      {
        "fields": [
          {
            "name": "axisP[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Pitch 50"
      }
    ]
  },
  {
    "title": "Yaw Std",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Motors"
      },
      {
        "fields": [
          {
            "name": "gyroADC[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffed6f",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#80b1d3",
            "lineWidth": 2
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#b3de69",
            "lineWidth": 2
          }
        ],
        "height": 1,
        "label": "GyroVSet 1000"
      },
      {
        "fields": [
          {
            "name": "axisP[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -100,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -100,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -100,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -100,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisF[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -100,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -100,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Yaw 50"
      }
    ]
  },
  {
    "title": "Roll Zoom",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommand[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 1000,
                "max": 2000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 1000,
                "max": 2000
              }
            },
            "color": "#ffed6f",
            "lineWidth": 2
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 2
          }
        ],
        "height": 1,
        "label": "Motors"
      },
      {
        "fields": [
          {
            "name": "gyroADC[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#fb8072",
            "lineWidth": 2
          },
          {
            "name": "rcCommands[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#fccde5",
            "lineWidth": 2
          },
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#ffed6f",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet 500"
      },
      {
        "fields": [
          {
            "name": "axisP[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Roll 20"
      }
    ]
  },
  {
    "title": "Pitch 200%",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 2
          }
        ],
        "height": 1,
        "label": "Motors"
      },
      {
        "fields": [
          {
            "name": "gyroADC[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#ffed6f",
            "lineWidth": 2
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#ffffb3",
            "lineWidth": 2
          },
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet 500"
      },
      {
        "fields": [
          {
            "name": "axisP[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Pitch 20"
      }
    ]
  },
  {
    "title": "Yaw 300%",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Motors"
      },
      {
        "fields": [
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#ffed6f",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#80b1d3",
            "lineWidth": 2
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#b3de69",
            "lineWidth": 2
          }
        ],
        "height": 1,
        "label": "GyroVSet 500"
      },
      {
        "fields": [
          {
            "name": "axisP[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisF[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -20,
                "max": 20
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Yaw 20"
      }
    ]
  },
  {
    "title": "Scratch",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "debug[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "debug[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "debug[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "debug[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "debug[4]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "debug[5]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          },
          {
            "name": "debug[6]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          },
          {
            "name": "debug[7]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Debug"
      }
    ]
  },
  {
    "title": "Scratch2",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Motors"
      },
      {
        "fields": [
          {
            "name": "gyroUnfilt[0]",
            "smoothing": 3000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 3000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "gyroUnfilt[1]",
            "smoothing": 3000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 3000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "gyroUnfilt[2]",
            "smoothing": 3000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "default": {
              "smoothing": 3000,
              "power": 1,
              "MinMax": {
                "min": -500,
                "max": 500
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Unfiltered Gyros"
      },
      {
        "fields": [
          {
            "name": "debug[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "debug[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "debug[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "debug[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -804,
                "max": 804
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "debug[4]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "debug[5]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          },
          {
            "name": "debug[6]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          },
          {
            "name": "debug[7]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 0
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Debug"
      }
    ]
  },
  {
    "title": "All Std",
    "graphConfig": [
      {
        "fields": [
          {
            "name": "gyroADC[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#fccde5",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet Roll"
      },
      {
        "fields": [
          {
            "name": "axisP[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[0]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs Roll 50"
      },
      {
        "fields": [
          {
            "name": "gyroADC[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffed6f",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet Pitch 1000"
      },
      {
        "fields": [
          {
            "name": "axisP[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisD[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "axisF[1]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PIDs pitch 50"
      },
      {
        "fields": [
          {
            "name": "gyroADC[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#80b1d3",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -1000,
                "max": 1000
              }
            },
            "color": "#b3de69",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "GyroVSet Yaw 1000"
      },
      {
        "fields": [
          {
            "name": "axisP[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "axisI[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "axisF[2]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": -50,
                "max": 50
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "PID Yaw 1000%"
      },
      {
        "fields": [
          {
            "name": "motor[0]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fb8072",
            "lineWidth": 1
          },
          {
            "name": "motor[1]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#8dd3c7",
            "lineWidth": 1
          },
          {
            "name": "motor[2]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#ffffb3",
            "lineWidth": 1
          },
          {
            "name": "motor[3]",
            "smoothing": 2000,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 2000,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#bebada",
            "lineWidth": 1
          },
          {
            "name": "rcCommands[3]",
            "smoothing": 0,
            "curve": {
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "default": {
              "smoothing": 0,
              "power": 1,
              "MinMax": {
                "min": 0,
                "max": 100
              }
            },
            "color": "#fdb462",
            "lineWidth": 1
          }
        ],
        "height": 1,
        "label": "Motors"
      }
    ]
  }
]
